<template>
    <div class="group">
        <div class="page-group-title"><span>品类信息</span></div>
        <el-row v-if="!formData.id" :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-form-item prop="propertyType" label="品类层级:">
                    <el-radio-group v-model="formData.propertyType" size="medium">
                        <el-radio :label="1" border>1级</el-radio>
                        <el-radio :label="2" border>2级</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item :prop="`properties[${0}].name`" :rules='[{required: true, message: "请输入1级品类标题"}]'>
                    <span slot="label">1级品类: <small> 1级品类标题如:颜色</small></span>
                    <el-input v-model.trim="formData.properties[0].name" placeholder="请输入1级品类标题" size="medium"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item :prop="`properties[${0}].value`" :rules='[{required: validateProperty, message: "请输入1级品类"}]'>
                    <span slot="label"> <small>多个1级品类以英文逗号分隔如:红,蓝</small></span>
                    <el-input v-model.trim="formData.properties[0].value" placeholder="请输入1级品类" size="medium"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row v-if="formData.propertyType == 2" :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item :prop="`properties[${1}].name`" :rules='[{required: true, message: "请输入2级品类标题"}]'>
                    <span slot="label">2级品类: <small> 2级品类标题如:尺码</small></span>
                    <el-input v-model.trim="formData.properties[1].name" placeholder="请输入2级品类标题" size="medium"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item :prop="`properties[${1}].value`" :rules='[{required: validateProperty, message: "请输入2级品类"}]'>
                    <span slot="label"><small>多个2级品类以英文逗号分隔如:M,L</small></span>
                    <el-input v-model.trim="formData.properties[1].value" placeholder="请输入2级品类" size="medium"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item>
            <el-button type="primary" size="medium" @click="createSku">点击创建</el-button>
        </el-form-item>
        <el-row :gutter="30" class="MT10">
            <el-col :xs="24" :xl="16">
                <el-form-item prop="shopGoodsSku" :rules='[{required: true, message: "请创建商品品类"}]' :show-message="formData.shopGoodsSku && formData.shopGoodsSku.length > 0? false : true">
                    <el-table
                        :data="formData.shopGoodsSku"
                        border
                        style="width: 100%"
                        size="small"
                        stripe
                    >
                        <el-table-column prop="imageUrl" label="预览图">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.imageUrl" :src="scope.row.imageUrl | coverImage(120)" fit="cover" :preview-src-list="[scope.row.imageUrl]" style="width:60px;height:60px;"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id" label="子类ID"></el-table-column>
                        <el-table-column prop="name" label="子类"></el-table-column>
                        <el-table-column prop="totalStock" label="总数"></el-table-column>
                        <el-table-column prop="sellStock" label="销量"></el-table-column>
                        <el-table-column prop="occupyStock" label="占用"></el-table-column>
                        <el-table-column label="剩余">
                            <template slot-scope="scope">{{scope.row.totalStock - scope.row.sellStock - scope.row.occupyStock}}</template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" v-if="scope.row.status < 0" type="info">已删除</el-tag>
                                <el-tag size="mini" v-else-if="scope.row.status == 0" >隐藏</el-tag>
                                <el-tag size="mini" v-else-if="scope.row.status == 1" type="success">正常</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="210">
                            <template slot-scope="scope">
                                <div v-if="scope.row.status >= 0">
                                    <el-button
                                        v-if="$utils.have('/shop_good/adjustStocks') && scope.row.id"
                                        type="text"
                                        size="small"
                                        @click="editTickStock(scope.row,scope.$index)"
                                        >修改库存</el-button
                                    >
                                    <el-popover v-if="!scope.row.id" placement="left" trigger="click">
                                        <div>{{scope.row.name}}库存</div>
                                        <div class="MT10">
                                            <el-input-number v-model="scope.row.totalStock" :min="0" :max="99999999" label="请输入库存总数"></el-input-number>
                                        </div>
                                        <el-button slot="reference" type="text" size="small">修改库存</el-button>
                                    </el-popover>
                                    <el-button
                                        type="text"
                                        size="small"
                                        @click="uploadImg(scope.row,scope.$index)"
                                        >上传图片</el-button
                                    >
                                    <el-button
                                        v-if="(scope.row.status == 0 || scope.row.status == 1) && (scope.row.sellStock != 0 || scope.row.occupyStock != 0)"
                                        type="text"
                                        size="small"
                                        @click="statusChange(scope.row,scope.$index)"
                                        >{{scope.row.status == 0 ? '展示' : '隐藏'}}</el-button
                                    >
                                    <el-button
                                        v-if="scope.row.sellStock == 0 && scope.row.occupyStock == 0"
                                        type="text"
                                        size="small"
                                        @click="del(scope.row,scope.$index)"
                                        >删除</el-button
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-col>
        </el-row>
        <SkuStockEdit ref="skuStockEdit" @updateStock="updateStock"></SkuStockEdit>
        <SkuImgUpload ref="skuImgUpload" @updateImg="updateImg"></SkuImgUpload>
    </div>
</template>

<script>
import SkuStockEdit from './sku-stock-edit';
import SkuImgUpload from './sku-img-upload';
export default {
    props:{
        formData: {
            type: Object,
            default: null
        },
        validateProperty:{
            type: Boolean,
            default: false
        }
    },
    components:{SkuStockEdit,SkuImgUpload},
    data(){
        return{

        }
    },
    methods:{
        
        //创建sku
        createSku(){
            const that = this;
            this.$emit('update:validateProperty',true);
            setTimeout(() => {
                this.$emit('validateField',['properties[0].name','properties[0].value','properties[1].name','properties[1].value'],() => {
                    const _item = {
                        name:'',
                        totalStock:0,
                        sellStock:0,
                        occupyStock:0,
                        status:1,
                        goodsId: this.formData.id
                    };
                    const _names = this.formData.shopGoodsSku.map( v => v.name);
                    const _arry1 = this.formData.properties[0] ? this.formData.properties[0].value.split(',') : [],
                        _arry2 = this.formData.propertyType == 2 && this.formData.properties[1] ? this.formData.properties[1].value.split(',') : [];

                    function setItem(name) {
                        if(!_names.find(v => v == name)){
                            that.formData.shopGoodsSku.push({
                                ..._item,
                                name: name
                            })
                        }       
                    };
                    
                    _arry1.forEach( (a) => {
                        if(_arry2 && _arry2.length > 0){
                            _arry2.forEach( (b) => {
                                const _name =  `${a}/${b}`;
                                setItem(_name);
                            })
                        }else{
                            setItem(a);
                        }
                    })
                })
            }, 300);
            
        },
        //编辑库存
        editTickStock(data,index){
            this.$refs.skuStockEdit.show(data,index);
        },
        updateStock(data){
            const _data = data;
            this.$set(this.formData.shopGoodsSku,_data.index,{
                ...this.formData.shopGoodsSku[_data.index],
                totalStock: _data.total,
            });
        },
        //上传图片
        uploadImg(data,index){
            this.$refs.skuImgUpload.show(data,index);
        },
        updateImg(data){
            const _data = data;
            this.$set(this.formData.shopGoodsSku,_data.index,{
                ..._data
            });
        },
        //删除
        del(data,index){
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                if(data.id){
                    this.formData.shopGoodsSku.map( (v,i) => {
                        if(v.id == data.id){
                            this.formData.shopGoodsSku[i].status = -1;
                        }
                    })
                }else{
                    this.formData.shopGoodsSku =  this.formData.shopGoodsSku.filter( v => v !== data);
                }
            }).catch(() => {})
        },
        //改变状态
        statusChange(data,index){
            const _status = data.status == 1 ? 0 : 1;
            const _msg = _status == 1 ? '确定要展示吗？' : '确定要隐藏吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$set(this.formData.shopGoodsSku,index,{
                    ...data,
                    status:_status,
                });
            }).catch(() => {})
        }
    }
    
}
</script>

<style lang="scss" scoped>
::v-deep .el-popover__reference{
    margin-right: 10px;
}
</style>